<template>
	<section v-if="items.length" class="main-content contentblocks">
		<slot name="blocks-header" />
		<content-block
			v-for="item in items"
			:key="item.ID"
			:image="item.image"
			:image-webp="item.imageWebp ?? ''"
			:image-alt="item.imageAlt ?? ''"
			:header="item.header"
			:content="item.content"
			class="row contentblock"
		/>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.contentblocks {
	background: var(--secondary-background-color);
}

@media (max-width: 1080px) {
	.contentblocks {
		padding: 50px 25px;
	}

	.contentblocks .row {
		max-width: 700px;
	}
}

@media (max-width: 880px) {
	.contentblocks .row:first-child {
		margin-top: 0;
	}

	.contentblocks .row:last-child {
		margin-bottom: 0;
	}
}
</style>
